import { styled } from '@mui/material/styles';
import Link from '@mui/material/Link';
import Container from '@mui/material/Container';
import MuiAccordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import { TrackButton } from 'components/TrackButton';
import { TrackingEvent } from 'lib/tracking/events';

const Accordion = styled(MuiAccordion)(({ theme }) => ({
  padding: `${theme.spacing(0.5)} 0`,
}));
const Center = styled('div')({
  textAlign: 'center',
});

const Button = styled(TrackButton)(({ theme }) => ({
  padding: `${theme.spacing(2)} ${theme.spacing(9)}`,
  height: '48px',
  width: '100%',
  [theme.breakpoints.up('md')]: {
    width: 'auto',
  },
}));

const FAQItem = ({
  question,
  answer,
}: {
  question: string | undefined;
  answer: string | undefined;
}) => (
  <Accordion>
    <AccordionSummary expandIcon={<ExpandMoreIcon color="primary" />}>
      <Typography
        color="primary"
        sx={{
          fontWeight: 500,
        }}
      >
        {question}
      </Typography>
    </AccordionSummary>
    <AccordionDetails>
      <Typography>{answer}</Typography>
    </AccordionDetails>
  </Accordion>
);

interface FaqEntry {
  question: string;
  answer: string;
}

export interface FaqProps {
  faqEntries: FaqEntry[];
  headline?: string;
  buttonText?: string;
  buttonUrl?: string;
}

export function FAQ(props: FaqProps) {
  const { faqEntries, headline, buttonText, buttonUrl } = props;
  const showButton = buttonText && buttonUrl;

  return (
    <Container maxWidth="md">
      <Box
        sx={{
          my: 12,
        }}
      >
        <Box
          sx={{
            mb: 6,
          }}
        >
          <Typography variant="h2" suppressHydrationWarning>
            {headline}
          </Typography>
        </Box>
        <Box
          sx={{
            mb: 4,
          }}
        >
          {faqEntries.map((entry: FaqEntry, key: number) => {
            const { question, answer } = entry;
            return <FAQItem key={key} question={question} answer={answer} />;
          })}
        </Box>
        <Center>
          {showButton && (
            <Link href={buttonUrl}>
              <Button
                variant="contained"
                trackingEvent={TrackingEvent.FAQ_BUTTON_ONINTERACT}
              >
                {buttonText}
              </Button>
            </Link>
          )}
        </Center>
      </Box>
    </Container>
  );
}
